import script from "./ConfiguratorChevron.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfiguratorChevron.vue?vue&type=script&setup=true&lang=ts"

import "./ConfiguratorChevron.vue?vue&type=style&index=0&id=2b2d8252&lang=css"

const __exports__ = script;

export default __exports__